module.exports = __webpack_public_path__ + "media/images/countrysquared/bw-8e85ec7c12ef48314cbd942707ac0c50.svg";